'use client';

import clsx from 'clsx';

import { SearchArticlesInput } from '../SearchArticlesInput';
import { Main } from './Main';
import { NotViewed } from './NotViewed';
import { Recommended } from './Recommended';
import styles from './ArticlesBlock.module.css';

interface ArticlesBlockProps {
  className?: string;
}

export const ArticlesBlock = ({ className }: ArticlesBlockProps) => {
  return (
    <div className={clsx(styles.root, className, 'scroll')}>
      <SearchArticlesInput />
      <Main />
      <Recommended />
      <NotViewed />
    </div>
  );
};
